import { lazy } from "react";
import Loadable from "app/components/Loadable";

const MyApps = Loadable(lazy(() => import("./MyApps")));
const MyAccountApps = Loadable(lazy(() => import("./MyAccountApps")));
const AppResourcesPage = Loadable(lazy(() => import("./AppResourcesPage")));
const AccountAppResourcesPage = Loadable(lazy(() => import("./AccountAppResourcesPage")));
const AppFormPage = Loadable(lazy(() => import("./AppFormPage")));

const sysadminMarketplaceRoutes = [
  { path: "sysadmin/marketplace-apps", element: <MyApps /> },
  { path: "sysadmin/marketplace-apps/:id/resources", element: <AppResourcesPage /> },
  { path: "sysadmin/marketplace-apps/:id", element: <AppFormPage /> },
  { path: "sysadmin/account-apps", element: <MyAccountApps /> },
  { path: "sysadmin/account-apps/:id/resources", element: <AccountAppResourcesPage /> },
];

export default sysadminMarketplaceRoutes;
